import { gql } from '@apollo/client';

export const CONVERSATION_QUERY = gql`
  query conversation($id: Int!) {
    conversation(id: $id) {
      id
      category
      subject
      status
      assignedToUserName
      assignedToUserPhotoUrl
      unreadCount
      messages {
        id
        read
        body
        fromPatient
        createdAt
        senderName
        senderTitle
        senderId
        attachments {
          fileName
          file
          id
          uuid
        }
        ai
      }
    }
  }
`;

export const MARK_CONVERSATION_READ = gql`
  mutation markConversationMessagesRead($id: Int!) {
    markConversationMessagesRead(id: $id) {
      conversation {
        id
        unreadCount
        lastMessageTimestamp
      }
    }
  }
`;
